import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const GallerySection = () => {
  const { t } = useLanguage();
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      src: 'https://customer-assets.emergentagent.com/job_rose-gold-salon-2/artifacts/5zgospcx_sirena10.jpeg',
      alt: 'مكياج احترافي',
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_rose-gold-salon-2/artifacts/ixa47n48_sirena8.jpeg',
      alt: 'صبغة شعر',
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_rose-gold-salon-2/artifacts/vpn0esl5_sirena7.jpeg',
      alt: 'رموش وحواجب',
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_rose-gold-salon-2/artifacts/agukrfp4_sirena6.jpeg',
      alt: 'أظافر فرنسي أزرق',
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_rose-gold-salon-2/artifacts/vabkqy4f_sirena5.jpeg',
      alt: 'أظافر بنفسجي مع ورود',
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_rose-gold-salon-2/artifacts/qu9u1gun_sirena4.jpeg',
      alt: 'أظافر ذهبية فرنسي',
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_rose-gold-salon-2/artifacts/sxowjwtj_sirena3.jpeg',
      alt: 'أظافر ملونة',
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_rose-gold-salon-2/artifacts/9nj7plui_sirena2.jpeg',
      alt: 'أظافر أزرق مع فيونكة',
    },
  ];

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="section-padding bg-[#F9F7F2]"
    >
      <div className="container mx-auto px-4 md:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-[#D4A39A] text-sm font-semibold uppercase tracking-widest">
            {t.gallery.subtitle}
          </span>
          <h2 
            data-testid="gallery-title"
            className="heading text-3xl md:text-4xl lg:text-5xl font-bold text-[#4A4A4A] mt-3"
          >
            {t.gallery.title}
          </h2>
        </motion.div>

        {/* Gallery Grid */}
        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <motion.div
              key={index}
              data-testid={`gallery-image-${index}`}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ scale: 1.03 }}
              onClick={() => setSelectedImage(image)}
              className="relative aspect-square rounded-2xl overflow-hidden cursor-pointer group"
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" />
            </motion.div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
            className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          >
            <button
              data-testid="lightbox-close"
              onClick={() => setSelectedImage(null)}
              className="absolute top-6 right-6 text-white hover:text-[#D4A39A] transition-colors"
            >
              <X className="w-8 h-8" />
            </button>
            <motion.img
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="max-w-full max-h-[90vh] rounded-xl object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};
